export default "__VITE_ASSET__CwiFt6zZ__"